import React from 'react';

const MentionContent = ({ children }) => (
  <span style={{ backgroundColor: '#e6f3ff' }}>
    {children}
  </span>
);

export default MentionContent;
